import DisplayHelpers from "@/helpers/display_helpers";

export enum VoicemailTemplateVariable {
  PATIENT_FIRST_NAME = 'patient_first_name',
  CALLER_NAME = 'caller_name',
  PROVIDER_NAME = 'provider_name',
  PRACTICE_NAME = 'practice_name',
  CALLBACK_NUMBER = 'callback_number',
}

export type VoicemailTemplateVariables = Partial<Record<VoicemailTemplateVariable, string>>;

const VARIABLE_PATTERN = /\{([a-z_]+)}/g;

/**
 * Substitutes {variable} placeholders in a voicemail template.
 * Unknown or not-yet-filled variables are intentionally left as-is so an admin editing the
 * config can still see which placeholders the recording will depend on at call time.
 */
export const resolveVoicemailTemplate = (
  template: string,
  variables: VoicemailTemplateVariables,
): string =>
  template.replace(VARIABLE_PATTERN, (placeholder, name: string) => {
    const value = variables[name as VoicemailTemplateVariable];

    if (value === VoicemailTemplateVariable.CALLBACK_NUMBER){
      return DisplayHelpers.formatPhoneNumber(value);
    }

    return value && value.trim().length > 0 ? value : placeholder;
  });

/** Variables referenced by a template, in order of first appearance, without duplicates. */
export const extractTemplateVariables = (template: string): string[] => {
  const found = template.match(VARIABLE_PATTERN) ?? [];
  return [...new Set(found.map((placeholder) => placeholder.slice(1, -1)))];
};

/** Placeholders used in the template that are not supported for the given variant. */
export const findUnsupportedVariables = (template: string, supported: VoicemailTemplateVariable[]): string[] =>
  extractTemplateVariables(template).filter((name) => !supported.includes(name as VoicemailTemplateVariable));
